import { TableCell } from "@mui/material";
import TableHeader from "@crema/core/AppTable/TableHeader";

const TableHeading = () => {
  return (
    <TableHeader>
      <TableCell align="left">S.No.</TableCell>
      <TableCell align="left">CRM Category</TableCell>
      <TableCell align="left">Client Category</TableCell>
      <TableCell align="left">Conditions</TableCell>
      <TableCell align="left">Status</TableCell> 
    </TableHeader>
  );
};

export default TableHeading;
